import {RouteLocationNormalizedGeneric} from "vue-router";
import {IRouteMeta} from "~/core-ui/ts/router/Interface";

export function getRealRouteMeta(route: RouteLocationNormalizedGeneric): IRouteMeta {
    return route.matched[route.matched.length - 1]?.meta as any;
}